
export default {
  countryContext: '',
  stateContext: '',
  cityContext: '',
  deferred: {},
  statesOptions: [],
  citiesOptions: [],
  countries: [],
  states: new Map(),
  cities: new Map(),
  status: '',
  cityFromCentroid: null,
  stateForCentroid: ''
};
